import { Action } from '@ngrx/store';

import { LanguageActionType } from './language-action-type.enum';

// languages
export class LoadLanguages implements Action {
  public readonly type: LanguageActionType = LanguageActionType.LoadLanguages;

  constructor(public readonly payload: any = undefined) { }
}

export class LoadLanguagesCompleted implements Action {
  public readonly type: LanguageActionType = LanguageActionType.LoadLanguagesCompleted;

  constructor(public readonly payload: {[key: string]: string}) { }
}

export class LoadLanguagesFailed implements Action {
  public readonly type: LanguageActionType = LanguageActionType.LoadLanguagesFailed;

  constructor(public readonly payload: string) { }
}
